/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

/**
 * @import IPowerManager from '../../../core/power/power-manager'
 */

/**
 * Správce napájení pro standardní webové technologie.
 * @implements {IPowerManager}
 */
export default class PowerManager {
  /**
   * Vytvoří instanci.
   */
  constructor() {
    this.bootDate = new Date();
  }

  /** @type {IPowerManager['ensureTimersAndHoliday']} */
  async ensureTimersAndHoliday(timersAndHoliday) {
    // TODO #55 Implementovat.
  }

  /** @type {IPowerManager['getBootDate']} */
  async getBootDate() {
    return await this.bootDate;
  }

  /** @type {IPowerManager['getHolidays']} */
  async getHolidays() {
    // Jelikož prázdniny neumíme nastavit a víme to, tak vracíme prázdné pole
    // místo undefined.
    return await [];
  }

  /** @type {IPowerManager['reboot']} */
  async reboot() {
    // Web neumožňuje restartovat prohlížeč. Provede pouze restart aplikace.
    await location.reload();
  }

  /** @type {IPowerManager['shutdown']} */
  async shutdown() {
    // #484 - Prázdná akce na platformě web, ochrana proti ztrátě řízení (původně se načítalo about:blank)
  }
}
